/*
 * Copyright (c) 2024 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

export enum CourierType {
  FED_EX = 'FED_EX',
  UPS = 'UPS',
  DHL = 'DHL'
}
